module.exports = __webpack_public_path__ + "static/images/Obee_Logo_140@2x.5353c76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Obee_Logo_140@2x.png
// module id = 28
// module chunks = 0